import {
  AvailabilityData,
  BookingHorizon,
  BufferMinutes,
  DayKey,
  WeeklyAvailability,
} from "./types";
import i18n from "locales/i18n";

const tc = i18n.getFixedT(null, "calendar");

export const DAY_ORDER: DayKey[] = [
  "mon",
  "tue",
  "wed",
  "thu",
  "fri",
  "sat",
  "sun",
];

// Getters so the labels follow the language switcher.
export const DAY_LABELS = Object.defineProperties(
  {},
  Object.fromEntries(
    (["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const).map((day) => [
      day,
      { get: () => tc(`days.${day}`), enumerable: true },
    ]),
  ),
) as Record<DayKey, string>;

// moment().day() index (0 = Sunday) -> DayKey, for mapping calendar dates to weekly hours.
export const WEEKDAY_INDEX_TO_KEY: Record<number, DayKey> = {
  0: "sun",
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
};

// Every day starts unavailable: a vendor turns on the days they take bookings.
export const DEFAULT_WEEKLY: WeeklyAvailability = {
  mon: { available: false, from: "09:00", to: "17:00" },
  tue: { available: false, from: "09:00", to: "17:00" },
  wed: { available: false, from: "09:00", to: "17:00" },
  thu: { available: false, from: "09:00", to: "17:00" },
  fri: { available: false, from: "09:00", to: "17:00" },
  sat: { available: false, from: "09:00", to: "17:00" },
  sun: { available: false, from: "09:00", to: "17:00" },
};

export const DEFAULT_AVAILABILITY: AvailabilityData = {
  weekly: DEFAULT_WEEKLY,
  customDates: [],
  bufferMinutes: 15,
  bookingHorizon: "2w",
  allowSameDayBookings: false,
};

export const BUFFER_OPTIONS: {
  id: number;
  label: string;
  value: BufferMinutes;
}[] = [
  { id: 1, value: 15 as const },
  { id: 2, value: 30 as const },
  { id: 3, value: 45 as const },
  { id: 4, value: 60 as const },
  { id: 5, value: 120 as const },
].map((option) => ({
  ...option,
  get label() {
    return tc(`buffer.${option.value}`);
  },
}));

export const HORIZON_OPTIONS: {
  id: number;
  label: string;
  value: BookingHorizon;
}[] = [
  { id: 1, value: "2w" as const },
  { id: 2, value: "4w" as const },
  { id: 3, value: "2m" as const },
  { id: 4, value: "3m" as const },
  { id: 5, value: "unlimited" as const },
].map((option) => ({
  ...option,
  get label() {
    return tc(`horizon.${option.value}`);
  },
}));

export const TIME_FORMAT = "HH:mm";
export const DATE_FORMAT = "YYYY-MM-DD";
